
import { useGammaWebServices, useLayout, useOrgSettings } from "@/services";
import {
  BottomTab,
  ERiskSummaryType,
  IJBACombinedRisk,
  RiskRecord,
} from "@/types";
import { defineComponent } from "vue";
import FloodClimateChangeRisks from "@/components/drawers/bottom/FloodClimateChangeRisks.vue";
import { mapState } from "pinia";

interface IRagScore {
  Color: string;
  Level: number;
  Description: string;
}
export default defineComponent({
  name: "RiskEntry",
  components: {
    FloodClimateChangeRisks,
  },
  props: {
    score: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    accuracy: {
      type: String,
      default: "--",
    },
    ragScore: {
      type: Object as () => IRagScore,
      required: true,
    },
    html: {
      type: String,
      default: "",
    },
    isPrintVersion: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number as () => ERiskSummaryType,
      required: false,
    },
    hideMoreInfoButton: {
      type: Boolean,
      default: false,
    },
    showRiskDetails: {
      type: Boolean,
      default: false,
    },
    isOtherRisk: {
      type: Boolean,
      default: false,
    },
    showFloodDetails: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    ...mapState(useGammaWebServices, ["riskRecords"]),
    getScoreIcon(): string {
      return this.color === "Green"
        ? "shield-fill-check"
        : this.color === "Amber"
        ? "exclamation-triangle-fill"
        : "exclamation-octagon-fill";
    },
    color(): string {
      return this.ragScore.Color || "";
    },
    description(): string {
      return this.ragScore.Description || "";
    },
    riskLookupDesc(): string | undefined {
      return this.type && this.type === ERiskSummaryType.FloodClimateChange
        ? useOrgSettings().riskLookups.find((x) => x.name === this.name)
            ?.description
        : undefined;
    },
    isDefaultType(): boolean {
      return this.type === ERiskSummaryType.Default;
    },
    jbaCombineRisk(): IJBACombinedRisk | undefined {
      return (this.riskRecords as RiskRecord[]).find(
        (x) => x.name === this.name
      )?.JBACombinedRisk;
    },
  },
  methods: {
    loaded(el: any) {
      if (el instanceof SVGElement) {
        el.classList.add("loaded");
      }
    },
    selectRisk(riskName: string) {
      const layout = useLayout();
      const { selectRisk, selectOtherRisk, selectedOtherRisk } =
        useGammaWebServices();

      if (this.isOtherRisk) {
        selectOtherRisk(
          selectedOtherRisk?.name === riskName ? undefined : riskName
        );
      } else {
        layout.setBottomActiveTab(
          BottomTab.RiskDetails,
          !layout.isBottomDrawerOpen
        );
        selectRisk(riskName);
      }

      layout.setRightSidebarStatus(false);
    },
  },
});
